module.exports = __webpack_public_path__ + "static/img/lea_logo.8136905.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing-icons/lea_logo.png
// module id = lqZm
// module chunks = 1